//@ts-nocheck

import React, { Component, ReactNode } from 'react';

interface ErrorBoundaryProps {
  // You can pass a fallback UI as a prop to customize it
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: React.ErrorInfo | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  // This lifecycle method is called when an error is thrown in a child component
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error, errorInfo: null };
  }

  // This lifecycle method provides error details
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      error,
      errorInfo,
    });
    // You can log the error to an external service like Sentry or LogRocket
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    const { hasError, error, errorInfo } = this.state;
    const { children, fallback } = this.props;

    // If an error is caught, render the fallback UI
    if (hasError) {
      return fallback ? (
        <>{fallback}</>
      ) : (
        <div>
          <h2>Something went wrong!</h2>
            {error && error.toString()}
            <br />
            {errorInfo?.componentStack}
        </div>
      );
    }

    // If no error, render the children components
    return <>{children}</>;
  }
}

export default ErrorBoundary;
